import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";
import moment from "moment";
import {
  nextStep,
  prevStep,
  addStepsData,
} from "app/lib/store/slices/steps/personalDetails";
import { usePersonalDetails } from "app/hooks/applicant/usePersonalDetails";
import { APPLICANT } from "app/constants/apiEndPoints";
import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import { PersonalFormTwoData } from "app/utils/types";
import DynamicFormTwo from "./dynamicForms/DynamicFormTwo";
import { handleApiError } from "app/utils/handleApiError";

const PartTwo: React.FC = () => {
  const applicantId = useSelector(
    (state: RootState) => state.loanTypesSteps.savedIds.applicantID
  );
  const dispatch = useDispatch();
  const { mutate: submitPersonalDetails, isPending } = usePersonalDetails();
  const { formTwo, ...others } = useSelector(
    (state: RootState) => state.personalDetails.stepsData
  );
  const { applicants } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },

    reset,
    setValue,
  } = useForm<PersonalFormTwoData>({
    defaultValues: {
      knownByOtherName: "no",
    },
  });
  const applicantName = watch("knownByOtherName");
  const onSubmit = (data: PersonalFormTwoData) => {
    const { knownByOtherName, dateOfBirth } = data;
    const formattedData = {
      ...data,
      dateOfBirth,
      knownByOtherName: knownByOtherName === "yes" ? true : false,
      drivingLicense: {
        ...data.drivingLicense,
        expiry: moment(data?.drivingLicense?.expiry).format("YYYY-MM-DD"),
      },
    };

    submitPersonalDetails(
      {
        url: `${APPLICANT}/${applicantId}/second`,
        data: formattedData,
      },
      {
        onSuccess: () => {
          dispatch(nextStep());
        },
        onError: (error: any) => {
          handleApiError(error);
        },
      }
    );
    dispatch(
      addStepsData({
        ...others,
        formTwo: formattedData,
      })
    );
  };

  useEffect(() => {
    if (formTwo) {
      reset({
        ...formTwo,
        knownByOtherName: formTwo.knownByOtherName ? "yes" : "no",
      });
    } else {
      const { dateOfBirth } = applicants || {};
      setValue("dateOfBirth", dateOfBirth || "");
    }
  }, [formTwo, reset]);

  return (
    <>
      <ProgressBar progress={25} MB={7} />
      <div className="w-full  sm:w-[70%] xl:w-[40%] mx-auto text-center px-4 sm:px-0">
        <MainTitle title="Personal Details" />

        <form onSubmit={handleSubmit(onSubmit)}>
          <DynamicFormTwo
            control={control}
            errors={errors}
            applicantName={applicantName as string}
            knownByOtherName="knownByOtherName"
            otherNameDesc="otherNameDesc"
            stateOfIssue="drivingLicense.stateOfIssue"
            drivingLicense="drivingLicense.number"
            dateOfBirth="dateOfBirth"
            expiry="drivingLicense.expiry"
          />
          <div className="flex justify-between my-10">
            <PreviousButtom onClick={() => dispatch(prevStep())}>
              Previous
            </PreviousButtom>
            <ContinueButton type="submit" loading={isPending}>
              Next
            </ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default PartTwo;
